<template>
    <treeselect
        :name="name"
        v-model="model"
        :options="options"
        :multiple="false"
        :clearable="true"
        :searchable="true"
        noResultsText="Nichts gefunden"
        placeholder="Vertretung suchen…"
    ></treeselect>
</template>

<script>
    import treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'

    export default {
        components: { treeselect },

        props: {
            name: { type: String, required: true },
            options: { type: Array, required: true },
            value: { type: Number, required: false, default: null },
        },

        data() {
            return {
                model: null,
            }
        },

        mounted() {
            this.model = this.value
        },
    }
</script>

<style>
    .vue-treeselect__placeholder {
        color: #000;
    }
</style>
